
export default {
  props: {
    author: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      isHover: false,
    }
  },
}
